module.exports = __webpack_public_path__ + "static/img/protect_5.44c1ed3c.png";